import { getToken } from "./storage";
import { baseUrl } from "./constants";

export async function searchStores(storeName) {
  let token = await getToken();

  let response = await (await fetch(`${baseUrl}/stores`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ name: storeName })
  })).json();

  return response;
}

export async function searchBranches(branchName) {
  let token = await getToken();

  let response = await (await fetch(`${baseUrl}/branches`, {
    headers: { Authorization: `Bearer ${token}` }
  })).json();

  response = response.data;

  return response;
}



// WEBPACK FOOTER //
// ./src/backend/stores.js